import { MARKETPLACE_ACCOUNT_COLLECTIONS } from "./marketplace_collections"

/**
 * The channel collections grouped by which AI surface their inbound messages land on. Mirrors
 * `aiChannelScope.utils.ts` in qpien-ai and api-v2's `MIGRATION_ID_REF_COLLECTIONS` — a group that
 * differs here makes the panel's count and the runner's selection disagree.
 */
export const SOCIAL_PAGE_COLLECTIONS: ReadonlyArray<string> = [
  "FacebookPages",
  "InstagramPages",
  "TiktokPages",
  "GoogleBusinessLocations"
]

export const CHAT_ONLY_COLLECTIONS: ReadonlyArray<string> = [
  "LiveChatAccounts",
  "WhatsAppBusinessPhones",
  "MetaWhatsAppBusinessPhones",
  "WhatsAppPhones",
  "TelegramAccounts",
  "CustomChannel",
  "Form",
  "PhoneNumbers"
]

export const EMAIL_ACCOUNT_COLLECTIONS: ReadonlyArray<string> = [
  "EmailAccounts"
]

/** Marketplaces whose only inbound message is a product QUESTION. */
export const QUESTION_ONLY_MARKETPLACE_COLLECTIONS: ReadonlyArray<string> = [
  "TrendyolAccounts",
  "HepsiburadaAccounts",
  "N11Accounts",
  "KauflandAccounts",
  "PazaramaAccounts"
]

/** Marketplaces whose buyer messages arrive as e-mail. */
export const EMAIL_MARKETPLACE_COLLECTIONS: ReadonlyArray<string> = [
  "AmazonAccounts",
  "WalmartAccounts"
]

export const ALL_MARKETPLACE_COLLECTIONS = MARKETPLACE_ACCOUNT_COLLECTIONS
